export default {
  'Resize for': '调整大小',
  'Add 10 videos at most': '最多添加10个视频。',
}